export default __webpack_public_path__ + "static/media/Rule7.85a8cfba.png";